import { Dropdown as AntDropdown, DropdownProps } from 'antd'
import { createGlobalStyle } from 'styled-components'

import { findScrollableParent } from '@/utils/findScrollableParent'

const DropdownGlobalStyle = createGlobalStyle`
  .bp-dropdown-overlay {
    & .ant-dropdown-menu-item-group-title {
      ${({ theme }) => theme.font.caption01};
      font-weight: 400;
      color: ${({ theme }) => theme.colour.secondary._400};
    }

    & .ant-dropdown-menu-item-group-list {
      margin-left: 0;
      margin-right: 0;

      & .ant-dropdown-menu-item {
        border-radius: 0 !important;
      }
    }
  }
`

type Props = DropdownProps

export const Dropdown: React.FC<Props> = (props) => {
  return (
    <>
      <DropdownGlobalStyle />
      <AntDropdown
        overlayClassName="bp-dropdown-overlay"
        getPopupContainer={findScrollableParent}
        {...props}
      />
    </>
  )
}

Dropdown.displayName = 'Dropdown'
